{
  "restoredMessage": "Restored \"{{manufacturer}} {{model}}\"",
  "restoreError": "Failed to restore. Please try again.",
  "emptyState": "No blacklisted FAA types. Use the \"Ignore\" button on the Aircraft Mapping tab to blacklist irrelevant aircraft types (drones, balloons, etc.)",
  "headers": {
    "manufacturer": "FAA Manufacturer",
    "model": "FAA Model",
    "restore": "Restore"
  },
  "restoreTooltip": "Restore this FAA type to Aircraft Mapping tab"
}
